import React, { useRef, useEffect, useState } from 'react';
import './Modal.css';

const Modal = ({closeText, isOpen, hasCloseBtn = true, onClose, children }) => {
  const [isModalOpen, setModalOpen] = useState(isOpen);
  const modalRef = useRef(null);

  const handleCloseModal = () => {
    if (onClose) {
      onClose();
    }
    setModalOpen(false);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Escape') {
      handleCloseModal();
    }
  };

  useEffect(() => {
    setModalOpen(isOpen);
  }, [isOpen]);

  useEffect(() => {
    const modalElement = modalRef.current;

    if (modalElement) {
      if (isModalOpen) {
        modalElement.showModal();
      } else {
        modalElement.close();
      }
    }
  }, [isModalOpen]);

  return (
    <dialog ref={modalRef} onKeyDown={handleKeyDown} className="modal p-10 pt-12 px-0">
      {hasCloseBtn && (
        <button type='button' className=" active:shadow-inner active:shadow-slate-200 absolute top-2 right-2 shadow-md hover:shadow-slate-400 bg-white flex flex-row gap-1 rounded-lg px-3  py-1 transition-shadow duration-200 cursor-pointer" onClick={handleCloseModal}>
          <p className='text-shadow-sm shadow-slate-200'>
            {closeText}
          </p>
        </button>
      )}
      {children}
    </dialog>
  );
};

export default Modal;
